import React from 'react';
import axios from 'axios';
import './index.scss';
import {smartJump} from 'utils/utils';

function Tabs({data = [], onChange = () => {}, curIndex, eidSuffix = ''}) {
    return (
        <div className="m-tabs g-flexbox">
            {
                data.map((item, index) => {
                    return (
                        <div className="tab-item flex" data-sk-eid={`tab_${eidSuffix}`} data-sk-edata={JSON.stringify({tabName: item.data.title})} key={index} onClick={() => onChange(index)}>
                            <div className={`tab ${index === curIndex ? 'active' : ''}`}>{item.data.title}</div>
                        </div>
                    );
                })
            }
        </div>
    );
}

export default function Layout({
    id = '',
    className = '',
    titImg = '',
    moduleName = '',
    renderList = function() {},
    tabData = [],
    displayLimit,
    more = {},
    eidSuffix = ''
}) {
    const [curIndex, setCurIndex] = React.useState(0);
    const [list, setList] = React.useState([]);
    const [limit, setLimit] = React.useState(displayLimit);
    React.useEffect(() => {
        if (!list[curIndex]) {
            const {id} = tabData[curIndex];
            axios.get(`//oss.dujia.qunar.com/cg/detail?pos=s_dlwlj22&modules=${moduleName}&types=4&pid=${id}`)
                .then(res => res.data)
                .then(res => {
                    list[curIndex] = res.data && res.data[moduleName] && res.data[moduleName][id] && res.data[moduleName][id].reduce((res, item) => {
                        return res.concat(Array.isArray(item.data) ? item.data : item);
                    }, []);
                    setList(list.slice());
                });
        }
    }, [curIndex, tabData]);
    const {data: {title: tabName = ''} = {}} = tabData[curIndex] || {};
    const data = list[curIndex] || [];
    return (
        <div className={`module m-nav ${className}`} id={id}>
            {titImg ? <img className="img-bg" src={titImg} /> : null}
            <Tabs data={tabData} curIndex={curIndex} onChange={setCurIndex} eidSuffix={eidSuffix}/>
            {
                data && renderList({list: displayLimit ? data.slice(0, limit) : data, tabName})
            }
            {
                (data && displayLimit && data.length > displayLimit || more.touchUrl) ?
                    <div className="m-more" data-sk-eid={`more_${eidSuffix}`} onClick={() => {
                        if(more.touchUrl) {
                            smartJump(more.touchUrl);
                        }else{
                            setLimit(limit ? undefined : displayLimit);
                        }
                    }}>
                        <div className="m-more-btn">{more.touchUrl ? '查看更多' : limit ? '展开更多' : '收起'}</div>
                    </div> : null
            }
        </div>
    );
}